export default {
    title: {
        new: "Dodaj nowy adres",
        complete: "Pełny adres",
        edit: "Edytuj adres"
    },
    incomplete: "Proszę wypełnić wymagane pola adresu",
    info: {
        "CHN": "Proszę wpisać adres w języku chińskim.</br> Proszę wpisać adres w języku chińskim.",
        "BGR": "Podaj swój <b>adres domowy</b> w języku angielskim, aby otrzymać przesyłkę.",
        "PRI": "Aby otrzymywać przesyłki, podaj adres domowy, a nie skrytkę pocztową.",
        "SGP": "Proszę podać w adresie numer swojej jednostki.",
        "SVK": "Proszę wpisać swój adres w <b>języku angielskim</b>",
        "POL": "Proszę wpisać swój adres w <b>języku angielskim</b>"
    },
    model: {
        country: {
            label: "Kraj"
        }
    },
    field: {
        default: {
            "name": {
                "label": {
                    "Name": "Nazwa"
                },
                "placeholder": {
                    "Name": "Nazwa",
                    "Name in English": "Imię po angielsku"
                }
            },
            personalEmail: {
                label: {
                    "Personal Email": "E-mail osobisty"
                },
                placeholder: {
                    "Personal Email": "E-mail osobisty"
                }
            },
            managerEmail: {
                label: {
                    "Manager Email": "E-mail menedżera"
                },
                placeholder: {
                    "Manager Email": "E-mail menedżera"
                }
            },
            managerName: {
                label: {"Manager Name": "Imię i nazwisko menedżera"},
                placeholder: {"Manager Name": "Imię i nazwisko menedżera"}
            },
            "postalCode": {
                "label": {
                    "Zipcode": "Kod pocztowy",
                    "Post Code": "Kod pocztowy",
                    "Postal Code": "Kod pocztowy",
                    "CPA": "Księgowy"
                },
                "placeholder": {
                    "Zipcode": "Kod pocztowy",
                    "Post Code": "Kod pocztowy",
                    "Postal Code": "Kod pocztowy",
                    "CPA": "Księgowy"
                }
            },
            "province": {
                "label": {
                    "Province": "Województwo",
                    "Prefecture": "Prefektura",
                    "Province/Region": "Prowincja/Region",
                    "Province Code": "Kod prowincji"
                },
                "placeholder": {
                    "Province": "Województwo",
                    "Prefecture": "Prefektura",
                    "Province/Region": "Prowincja/Region",
                    "Province Code": "Kod prowincji"
                }
            },
            "phoneNumber": {
                "label": {
                    "Phone Number": "Numer telefonu"
                },
                "placeholder": {
                    "Phone Number": "Numer telefonu"
                }
            },
            "secondaryPhoneNumber": {
                "label": {"Secondary Phone Number": "Dodatkowy numer telefonu"},
                "placeholder": {"Secondary Phone Number": "Dodatkowy numer telefonu"}
            },
            "firstStreet": {
                "label": {
                    "Street": "Ulica",
                    "Tax ID": "Identyfikator podatkowy"
                },
                "placeholder": {
                    "Street": "Ulica",
                    "Street in English": "Ulica po angielsku",
                    "Tax ID (RUT)": "Identyfikator podatkowy (RUT)",
                    "Number/Street/Apartment": "Numer/Ulica/Mieszkanie"
                }
            },
            "secondStreet": {
                "label": {
                    "District": "Dzielnica",
                    "Colonia": "Kolonia",
                    "Canton": "Kanton",
                    "Street": "Ulica"
                },
                "placeholder": {
                    "District": "Dzielnica",
                    "Colonia": "Kolonia",
                    "Canton": "Kanton",
                    "Number/Street/Apartment": "Numer/Ulica/Mieszkanie"
                }
            },
            "city": {
                "label": {
                    "City": "Miasto",
                    "Town/City/Locality": "Miejscowość/Miasto/Lokalizacja",
                    "Town/City": "Miasto",
                    "City/Municipality/Locality": "Miasto/Gmina/Miejscowość",
                    "City/Town/Locality": "Miasto/Miasteczko/Lokalizacja",
                    "City/Town": "Miasto/Miasteczko",
                    "District": "Dzielnica",
                    "City/Town/Locallity": "Miasto/Miasteczko/Lokalizacja",
                    "Town/City/Sub Locality": "Miejscowość/Miasto/Podmiejscowość"
                },
                "placeholder": {
                    "City": "Miasto",
                    "Town/City": "Miasto",
                    "Town/City/Locality": "Miejscowość/Miasto/Lokalizacja",
                    "City/Municipality/Locality": "Miasto/Gmina/Miejscowość",
                    "City/Town/Locality": "Miasto/Miasteczko/Lokalizacja",
                    "City/Town in English": "Miasto/Miasteczko w języku angielskim",
                    "District": "Dzielnica",
                    "City/Town/Locallity": "Miasto/Miasteczko/Lokalizacja",
                    "Town/City/Sub Locality": "Miejscowość/Miasto/Podmiejscowość"
                }
            },
            identifier: {
                label: {
                    "identifier": "Identyfikator",
                    "Identifier": "Identyfikator"
                },
                placeholder: {
                    "identifier": "Identyfikator",
                    "Identifier": "Identyfikator"
                }
            },
            "region": {
                "label": {
                    "Region": "Region",
                    "County": "Hrabstwo",
                    "Locality": "Miejscowość"
                },
                "placeholder": {
                    "Region": "Region",
                    "County": "Hrabstwo",
                    "Locality": "Miejscowość"
                }
            },
            "poBox": {
                "label": {
                    "PO BOX": "SKRYTKA POCZTOWA"
                },
                "placeholder": {
                    "PO BOX": "SKRYTKA POCZTOWA"
                }
            },
            state: {
                "label": {
                    "State": "Państwo",
                    "Province/Region": "Prowincja/Region",
                    "Province": "Województwo",
                    "Department": "Dział",
                    "Municipality/Comuna": "Miasto"
                },
                "placeholder": {
                    "State": "Państwo",
                    "Province/Region": "Prowincja/Region",
                    "Province": "Województwo",
                    "Department": "Dział",
                    "Municipality/Comuna": "Miasto"
                },
                options: {
                    "Alabama": "Alabama",
                    "Alaska": "Alaska",
                    "Arizona": "Arizona",
                    "Arkansas": "Arkansas",
                    "California": "Kalifornia",
                    "Colorado": "Kolorado",
                    "Connecticut": "Connecticut",
                    "Delaware": "Delaware",
                    "District Of Columbia": "Dystrykt Kolumbii",
                    "Florida": "Floryda",
                    "Georgia": "Gruzja",
                    "Hawaii": "Hawaje",
                    "Idaho": "Idaho",
                    "Illinois": "Illinois",
                    "Indiana": "Indiana",
                    "Iowa": "Iowa",
                    "Kansas": "Kansas",
                    "Kentucky": "Kentucky",
                    "Louisiana": "Luizjana",
                    "Maine": "Maine",
                    "Maryland": "Maryland",
                    "Massachusetts": "Massachusetts",
                    "Michigan": "Michigan",
                    "Minnesota": "Minnesota",
                    "Mississippi": "Missisipi",
                    "Missouri": "Missouri",
                    "Montana": "Montana",
                    "Nebraska": "Nebraska",
                    "Nevada": "Nevada",
                    "New Hampshire": "Nowy Hampshire",
                    "New Jersey": "Nowy Jork",
                    "New Mexico": "Nowy Meksyk",
                    "New York": "Nowy Jork",
                    "North Carolina": "Karolina Północna",
                    "North Dakota": "Dakota Północna",
                    "Ohio": "Ohio",
                    "Oklahoma": "Oklahoma",
                    "Oregon": "Oregon",
                    "Pennsylvania": "Pensylwania",
                    "Rhode Island": "Rhode Island",
                    "South Carolina": "Karolina Południowa",
                    "South Dakota": "Dakota Południowa",
                    "Tennessee": "Tennessee",
                    "Texas": "Teksas",
                    "Utah": "Utah",
                    "Vermont": "Vermont",
                    "Virginia": "Wirginia",
                    "Washington": "Waszyngton",
                    "West Virginia": "Wirginia Zachodnia",
                    "Wisconsin": "Wisconsin",
                    "Wyoming": "Wyoming"
                }
            },
            "deliveryInstructions": {
                "label": {
                    "Delivery Instructions": "Instrukcje dostawy"
                },
                "placeholder": {
                    "Extra address information, delivery instructions, etc. ": "Dodatkowe informacje adresowe, instrukcje dostawy itp. ",
                    "Extra address information, delivery instructions, etc. in English ": "Dodatkowe informacje adresowe, instrukcje dostawy itp. w języku angielskim ",
                    "Extra address information, delivery instructions, etc": "Dodatkowe informacje adresowe, instrukcje dotyczące dostawy itp."
                }
            },
        },
        BRA: {
            name: {
                label: {"Full name": "Pełne imię i nazwisko"},
                placeholder: {"Full name": "Pełne imię i nazwisko"}
            },
            firstStreet: {
                label: {"Address 1": "Adres 1"},
                placeholder: {"Address 1": "Ulica + numer domu/mieszkania"}
            },
            secondStreet: {
                label: {
                    "Address 2": "Adres 2",
                    "District": "Dzielnica"
                },
                placeholder: {
                    "Address 2": "Ulica + numer domu/mieszkania",
                    "District": "Dzielnica"
                }
            },
            city: {
                label: {City: "Miasto"},
                placeholder: {City: "Miasto"},
            },
            state: {
                label: {State: "Państwo"},
                placeholder: {State: "Państwo"}
            },
            "postalCode": {
                "label": {
                    "Zipcode": "Kod pocztowy",
                    "Post Code": "Kod pocztowy",
                    "Postal Code": "Kod pocztowy",
                    "CPA": "Księgowy"
                },
                "placeholder": {
                    "Zipcode": "Kod pocztowy",
                    "Post Code": "Kod pocztowy",
                    "Postal Code": "Kod pocztowy",
                    "CPA": "Księgowy"
                }
            },
            identifier: {
                "label": {
                    "Tax ID": "Identyfikator podatkowy"
                },
                "placeholder": {
                    "Tax ID (CDI, CUIT, CUIL, etc)": "Identyfikator podatkowy (CDI, CUIT, CUIL itp.)"
                }
            }
        },
        IND: {
            state: {
                label: {"State/Territory": "Stan/Terytorium"},
                options: {
                    "Andaman and Nicobar Islands": "Wyspy Andamany i Nikobary",
                    "Arunachal Pradesh": "Arunachal Pradesh",
                    "Assam": "Assam",
                    "Bihar": "Bihar",
                    "Chandigarh": "Czandigarh",
                    "Chhattisgarh": "Chhattisgarh",
                    "Dadra and Nagar Haveli and Daman and Diu": "Dadra i Nagar Haveli i Daman i Diu",
                    "Delhi": "Delhi",
                    "Goa": "Goa",
                    "Gujarat": "Gudżarat",
                    "Haryana": "Haryana",
                    "Himachal Pradesh": "Himachal Pradesh",
                    "Jammu and Kashmir": "Dżammu i Kaszmir",
                    "Jharkhand": "Dżharkhand",
                    "Karnataka": "Karnataka",
                    "Kerala": "Kerala",
                    "Ladakh":"Ladakh",
                    "Lakshadweep": "Lakszadweep",
                    "Madhya Pradesh": "Madhya Pradesh",
                    "Maharashtra": "Maharasztra",
                    "Manipur": "Manipur",
                    "Meghalaya": "Meghalaya",
                    "Mizoram": "Mizoram",
                    "Nagaland": "Nagaland",
                    "Odisha": "Odisza",
                    "Puducherry": "Puducherry",
                    "Punjab": "Pendżab",
                    "Rajasthan": "Radżastan",
                    "Sikkim": "Sikkim",
                    "Tamil Nadu": "Tamil Nadu",
                    "Telangana":"Telangana",
                    "Tripura": "Trypura",
                    "Uttar Pradesh": "Uttar Pradesh",
                    "Uttarakhand": "Uttarakhand",
                    "West Bengal": "Bengal Zachodni",
                    "Andhra Pradesh": "Andhra Pradesh"
                }
            }
        }
    },
    errors: {
        required: "{field} jest wymagane.",
        mask: "{field} jest nieprawidłowe."
    },
    buttons: {
        submit: {
            text: "Ratować",
            saving: "Oszczędność"
        },
        cancel: {
            text: "Anulować"
        }
    },
    disclaimer: "Dodanie tego adresu będzie wymagało weryfikacji adresu e-mail. Po zapisaniu adresu sprawdź swoją skrzynkę e-mail i kliknij link w niej zawarty.",
    message: {
        added: "Dodano adres",
        updated: "Adres został zaktualizowany"
    }
}